<template>
  <div ref="loading"></div>
</template>

<script>
// @ts-nocheck

import Two            from "two.js";
import {gsap, Power2} from "gsap";

export default
{
  name: "Loading.vue",
  data ()
  {
      return {
        two: null,
        points: [],
        endPoints: [],

        strMode: "loop",
        animateBezierSpeed: 60,
        bShouldAnimateBezier: true,

        //Yeah, that sort of suck.
        //No real way to extract the path from After Effects, so this was trial and error.
        goalPoints: [
          new Two.Anchor( 4, 66, 0, 0, 105, 0, Two.Commands.move),
          new Two.Anchor( 157, 44, -25, 0, 21, 0, Two.Commands.curve),
          new Two.Anchor( 216, 51, -20, 0, 15, 0, Two.Commands.curve),
          new Two.Anchor( 261, 43, -15, -1, 18, 1, Two.Commands.curve),
          new Two.Anchor( 309, 54, -13, 0, 18, 0, Two.Commands.curve),
          new Two.Anchor( 361, 45, -19, 0, 21, 0, Two.Commands.curve),
          new Two.Anchor( 424, 56, -21, -2, 17, 2, Two.Commands.curve),
          new Two.Anchor( 476, 56, -17, -1, 40, 4, Two.Commands.curve),
          new Two.Anchor( 643, 66, -105, 0, 0, 0, Two.Commands.curve),
        ],

        imgRect: null,
        img: null,
        bgFill: null,
        bgCurveFill: null,
        bg: null,
        bgCurve: null,
        fg: null,
        fgCurve: null,
        fgEnd: null,
        fgEndCurve: null,
        rectMask: null,

        addedViewBox:false,
        twoContainer: null,
        loadingSize:{width: 652, height: 70},
        goalSize:{width: 652, height: 70},
      }
  },


  methods:
    {
        onReady ()
        {
          this.two = new Two({width: 652, height: 70, fitted: false});

          //this.two = new Two(this.loadingSize);
          this.two.appendTo(this.$refs.loading);
          this.two.renderer.domElement.setAttribute('viewBox', `0 0 652 70`);

          this.prepare ();
          this.update();

        },




        prepare ()
        {
          for (let i = 0; i < this.goalPoints.length; i++)
          {
            let anchorGoal = this.goalPoints[i];

            let anchor = new Two.Anchor(anchorGoal.x, 66, 0, 0, 0, 0, i === 0 ? Two.Commands.move : Two.Commands.curve);
            this.points.push(anchor);
          }

          this.loadMemorial();

          this.drawBottomCache(); //trying yto hide the bottom letter when the fill animate up

          this.drawBgFill();
          this.drawBgCurve();
          this.drawFgCurve();
          this.drawFgEndCurve();
          this.drawMask();
          this.applyMask();

          let start = {x: 4, y: 66};
          let end = {x: 648, y: 66};

          this.drawDiamond(start);
          this.drawDiamond(end);


        },


      loadMemorial ()
      {
        let offset = 650 - 512;
        this.imgRect = this.two.makeRectangle(512 / 2 + (offset / 2), 66 / 2, 512, 66);
        this.imgRect.translation.y = 70 + 35;

        this.img = new Two.Texture("/_/images/loading/memorial_logo.png",  (a,b,c) =>
        {
          this.imgRect.noStroke().fill = this.img;
         //this.imgRect.mask = this.bgCurveFill;
        })

      },


      drawDiamond (center)
      {


        let diamond = this.two.makePath(
          center.x - 4, center.y,
          center.x , center.y - 4,
          center.x + 4, center.y ,
          center.x , center.y + 4 ,
          center.x - 4, center.y);

        diamond.fill = 'rgba(0, 0, 0, 1)';
        diamond.stroke = 'rgba(0, 0, 0, 1)';

      },

      drawBottomCache ()
      {
          let cache = new Two.Rectangle(652 / 2, 69, 652, 2);
          cache.stroke = 'rgba(255, 255, 255, 1)';
          cache.fill = 'rgba(255, 255, 255, 1)';
          this.two.add(cache);
      },


      drawBgFill ()
      {
        //this.bgFill = new Two.Group();
        this.bgCurveFill = this.drawCurveFill('rgba(255, 255, 255, 1)')
        //this.bgFill.add(this.bgCurveFill);


        //this.two.add(this.bgFill);
        this.two.add(this.bgCurveFill);

      },

      drawBgCurve ()
      {
        this.bg = new Two.Group();
        this.bgCurve = this.drawCurve('rgba(47, 50, 59, 0.15)')
        this.bg.add(this.bgCurve);

        this.two.add(this.bg);
      },

      drawFgCurve ()
      {
        this.fg = new Two.Group();
        this.fgCurve = this.drawCurve('rgba(47, 50, 59, 1)')
        this.fg.add(this.fgCurve);

        this.two.add(this.fg);
      },

      drawFgEndCurve ()
      {
        this.fgEnd = new Two.Group();
        this.fgEndCurve = this.drawCurve('rgba(47, 50, 59, 1)')
        this.fgEnd.add(this.fgEndCurve);
        this.fgEnd.opacity = 0;

        this.two.add(this.fgEnd);
      },

      drawMask ()
      {
        this.rectMask = new Two.Rectangle(652 / 2,70 / 2, 652, 70);

        //this.rectMask.origin = new Two.Vector(652 / -2, 70 / -2);
        this.rectMask.fill = 'rgba(0, 0, 200, 0.5)';
        this.rectMask.stroke = 'rgba(0, 0, 0, 0)';
        this.rectMask.position.x = 652 / -2;


        this.two.add(this.rectMask);
      },

      drawCurve (color)
      {
        let bezierPath = new Two.Path(this.points);
        bezierPath.automatic = false;
        bezierPath.linewidth = 2;
        bezierPath.stroke = color;
        bezierPath.noFill();

        return bezierPath;
      },

      drawCurveFill (color, mode = "down")
      {
        let fill = [...this.points];

        if (mode === "down")
        {
          fill.push(new Two.Anchor(652, 80, 0, 0, 0, 0, Two.Commands.line));
          fill.push(new Two.Anchor(0, 80, 0, 0, 0, 0, Two.Commands.line));
        }
        else
        {
          fill.push(new Two.Anchor(652, 0, 0, 0, 0, 0, Two.Commands.line));
          fill.push(new Two.Anchor(0, 0, 0, 0, 0, 0, Two.Commands.line));
        }
        //fill.push(new Two.Anchor(0, 72,  5,5, -5, -5, Two.Commands.close));

        let bezierPath = new Two.Path(fill);

        bezierPath.automatic = false;
        bezierPath.linewidth = 0;
        bezierPath.stroke = color;
        bezierPath.fill = color;

        return bezierPath;
      },

      applyMask ()
      {
        this.fg.mask = this.rectMask;
        //this.img.mask = this.bgFill;
        //this.imgRect.mask = this.bgCurveFill;
      },



      update ()
      {
        requestAnimationFrame( () => this.update());
        this.animate();
        this.two.update();
      },

      animate ()
      {
        if (this.strMode === "loop")
        {
          this.animateMask();
        }

        this.animateBezier();
      },

      animateMask ()
      {
        if (!this.rectMask)
          return;

        let speed = this.maskHasReachEnd()  ? 5 : 3;
        this.rectMask.position.x += speed;

        if (this.rectMask.position.x > (652 * 1.5))
        {
          this.rectMask.position.x = 652 * -0.5;
        }

      },

      animateBezier ()
      {
        if (!this.bShouldAnimateBezier)
          return;

        for (let i = 0; i  < this.points.length; i++)
        {
          this.points[i].y += this.offsetValue(this.goalPoints[i].y , this.points[i].y);
          this.points[i].controls.left.x += this.offsetValue(this.goalPoints[i].controls.left.x , this.points[i].controls.left.x);
          this.points[i].controls.left.y += this.offsetValue(this.goalPoints[i].controls.left.y , this.points[i].controls.left.y);
          this.points[i].controls.right.x += this.offsetValue(this.goalPoints[i].controls.right.x , this.points[i].controls.right.x);
          this.points[i].controls.right.y += this.offsetValue(this.goalPoints[i].controls.right.y , this.points[i].controls.right.y);
        }
      },

      offsetValue (val1, val2)
      {
        let diff = val1 - val2;
        let offset = diff / (this.animateBezierSpeed * 10);

        return offset;
      },

      maskHasReachEnd ()
      {
        return this.rectMask.position.x > (652 / 2);
      },

      startLoadingComplete ()
      {
        this.strMode = "ending";

        this.startAnimateEndLoop();
        gsap.to(this.imgRect.position, {y: 35, duration: 3, ease:Power2.easeOut})
      },

      startAnimateEndLoop()
      {
        gsap.to(this.fgEnd, { opacity: 1, duration: 1.5, ease:Power2.easeOut, onComplete: () => this.onAnimateEndLoopComplete() })
        this.animateBezierSpeed = 5;
      },

      onAnimateEndLoopComplete ()
      {
        this.rectMask.position.x  = (652 * 1.5);

        // if (this.$refs.loading)
        // {
        //   this.fct = this.onMouseMove.bind(this);
        //   this.svg = this.two.renderer.domElement
        //   this.svg .addEventListener("mousemove", this.fct)
        //
        //   this.svgRect = this.svg.getBoundingClientRect();
        // }
      },


      //
      // onMouseMove (e)
      // {
      //   let x = e.pageX - this.svgRect.x;
      //   let y = e.pageY - this.svgRect.y;
      //
      //   let closest = this.findClosestPoint(x);
      //   let ptClosest = this.points[closest];
      //
      //   if (closest > 0 && closest < (this.points.length - 1))
      //   {
      //     ptClosest.y -= (ptClosest.y - y) / 60;
      //   }
      //
      // },
      //
      // findClosestPoint (x)
      // {
      //   let diff = Number.POSITIVE_INFINITY;
      //   let index = -1;
      //
      //   for (let i = 0; i < this.points.length; i++)
      //   {
      //     let pt = this.points[i];
      //     let currentDiff = Math.abs(pt.x - x);
      //
      //     if (currentDiff < diff)
      //     {
      //       diff = currentDiff;
      //       index = i
      //     }
      //   }
      //
      //   return index;
      // }


    },

  unmounted()
  {
    if (this.fct && this.svg )
    {
      this.svg .removeEventListener("mousemove", this.fct)
    }
  },

  mounted ()
  {
      this.onReady();


  }
}
</script>

<style scoped>

</style>
